module.exports = __webpack_public_path__ + "img/syukyaku-top-back001.9413c3b0.jpg";